module.exports = __webpack_public_path__ + "static/SLFCspread-1-09111d48091454ba0ea1dbbca750815a.jpg";